<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Monthly Attendance Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        @click="putnull" persistent-hint hint="Please Select Academic Year " />
                </v-col>

                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv"
                        @click="putnull" persistent-hint hint="Please Select Standard " />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                        item-text="name" item-value="name" label="Select Year" outlined persistent-hint
                        hint="Please Select Year" />
                </v-col>
                <v-col cols="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="month" :items="month_list"
                        item-text="name" return-object label="Select Month" outlined persistent-hint
                        hint="Please Select Month" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
                        item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data && sel_std_data && div && month && year">
                    <v-btn class="mt-6 button" @click="getMonthlyAttendanceData()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="month_attendance != ''">
            <v-col sm="2">
                <v-btn rounded color="success" outlined
                    @click="fnExcelReport('my-table-id', 'MonthlyAttendendanceReport')" :loading="loader"><v-icon
                        color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <div id="my-table-id">
                <v-simple-table></v-simple-table>
                <div v-if="org_basic_data">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="4" md="8">
                            <center>
                                <h2>
                                    <strong>{{ org_basic_data.trust_name }}</strong>
                                </h2>
                                <h3>
                                    <strong>{{ org_basic_data.school_name }} </strong>
                                </h3>
                            </center>
                        </v-col>
                    </v-row>
                </div>
                <div>
                    <center>
                        <strong>
                            ATTENDANCE FOR {{sel_std_data.std}} {{div.div_name}} THE MONTH OF {{ month.name }} {{year}}
                        </strong>
                    </center>
                </div>
                <!-- <center>
    <table dense width="1000px" class="elevation-1 table">
        <thead>
            <tr>
                <th class="table">
                    <center>
                        <strong>
                            <h2>
                                <span v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</span>
                            </h2>
                        </strong>
                        <strong>
                            <h3>
                                <span v-if="org_basic_data.school_name">{{ org_basic_data.school_name }}</span>
                            </h3>
                        </strong>
                        <strong>
                            <h4>
                                ATTENDANCE FOR {{sel_std_data.std}} {{div.div_name}} THE MONTH OF {{ month.name }} {{year}}
                            </h4>
                        </strong>
                        <br />
                    </center>
                </th>
            </tr>
        </thead>
    </table>
</center> -->

                <div class="scroll">
                    <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                        <thead>
                            <tr>
                                <th class="">Sr. No.</th>
                                <th class="">Registration No.</th>
                                <th class="">Roll No.</th>
                                <th class="">Name</th>
                                <th class="">Date Of Birth</th>
                                <!-- <th class="">Standard</th>
                                <th class="">Division</th>
                                <th class="">Admission Year</th> -->
                                <th class="" v-for="i,index4 in date_header" :key="index4">{{i}}</th>
                                <th colspan="4" class="">No. Of Attendance Max. Att.</th>
                            </tr>
                        </thead>
                        <tbody style="overflow-y: scroll;">
                            <tr v-for="(s, index1) in month_attendance" :key="s.id">
                                <td>{{ index1 + 1 }}</td>
                                <td>{{ s.reg_no }}</td>
                                <td>{{ s.roll_no }}</td>
                                <td v-if="org_id=='wws'">
                                    <span v-if="s.name_as_on_aadhar_card">
                                        {{ s.name_as_on_aadhar_card }}
                                    </span>
                                    <span v-else>
                                        {{ s.name }}
                                    </span>
                                </td>
                                <td v-else>{{ s.name }}</td>
                                <td>{{ s.dob }}</td>
                                <!-- <td>{{ s.standard }}</td>
                                <td>{{ s.division }}</td>
                                <td>{{ s.learner_addmission_year }}</td> -->
                                <td v-for="j,index in s.day_att" :key="index">{{ j }}</td>
                                <td>
                                    {{s.present_cnt}}
                                </td>
                                <td>
                                    {{ s.overall_attendance - s.present_cnt}}
                                </td>
                                <td>{{ s.overall_attendance }}</td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <strong>Total Girls : </strong> {{total_girls}} <br />
                                    <hr />
                                    <strong>Total Boys : </strong> {{total_boys}}
                                </td>
                                <td v-for="j,index in date_size" :key="index"></td>
                                <td>{{total_present}}</td>
                                <td>{{total_previous}}</td>
                                <td>{{total_overall}}</td>
                            </tr>
                            <tr>
                                <td :colspan="5 + date_size">
                                    <v-row dense justify="center" v-for="index,i in total_holidays" :key="index">
                                        <strong>{{i+1}}.</strong> {{index}}</v-row>
                                </td>
                                <td>
                                    <br />
                                    <br />
                                    <br />
                                    <hr />
                                    <br />
                                    <strong>Class Teacher</strong>
                                </td>
                                <td>
                                    <br />
                                    <br />
                                    <br />
                                    <hr />
                                    <br />
                                    <strong>Checked By</strong>
                                </td>
                                <td>
                                    <strong>Total No. Of Working Days - {{total_working_days}} </strong>
                                    <hr />
                                    <strong>Daily Average Attendance</strong>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </div>
        </v-card>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

        data: () => ({
            loader: false,
            snackbar_msg: "",
            // extraBreadcrumbItems: [
        

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            headers: [
                { text: "Sr No", value: "srno" },
                // { text: "Date", value: "date" },
                { text: "Learner", value: "learner" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "division" },
                { text: "Roll No", value: "roll_no" },
                { text: "Total", value: "total" },
                { text: "Present", value: "total_present" },
                { text: "Absent", value: "total_absent" },
                { text: "Percentage", value: "percentage" },
            ],
            table_fields: {
                "Sr No ": "srno",
                Learner: "learner",
                Standard: "standard",
                Division: "division",
                Total: "total",
                Present: "total_present",
                Absent: "total_absent",
                Percentage: "percentage",
            },
            ay_std_div_list: null,
            sel_ay_data: null,
            show_tt: false,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            fetch_loader: false,
            month_attendance: [],
            picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            date: new Date().toISOString().substr(0, 7),
            //date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            modal: false,
            learner_attendance_info: [],
            date_header: [],
            month: null,
            year: "",
            org_id: null,
            year_list: [],
            month_list: [
                { name: "January", id: "1", month_number: "1" },
                { name: "February", id: "2", month_number: "2" },
                { name: "March", id: "3", month_number: "3" },
                { name: "April", id: "4", month_number: "4" },
                { name: "May", id: "5", month_number: "5" },
                { name: "June ", id: "6", month_number: "6" },
                { name: "July", id: "7", month_number: "7" },
                { name: "August", id: "8", month_number: "8" },
                { name: "September", id: "9", month_number: "9" },
                { name: "October", id: "10", month_number: "10" },
                { name: "November", id: "11", month_number: "11" },
                { name: "December", id: "12", month_number: "12" },
            ],
            total_girls: null,
            total_boys: null,
            total_present: null,
            total_previous: null,
            total_overall: null,
            date_size: null,
            org_basic_data: [],
            total_working_days: null,
            total_holidays: null,
            role: null,
            status_list: [],
            stud_status: null,
        }),
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            getMonthlyAttendanceData() {
                const data = {
                    month: this.date,
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division_offering: this.div,
                    months: this.month.id,
                    year: this.year,
                    stud_status: this.stud_status.id,
                };
                this.overlay = true;
                axios
                    .post("/Academics/getWWSMonthlyAttendanceData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.month_attendance = res.data.month_attendance;
                            this.date_header = res.data.date_header;
                            this.total_girls = res.data.total_girls;
                            this.total_boys = res.data.total_boys;
                            this.total_present = res.data.total_present;
                            this.total_previous = res.data.total_previous;
                            this.total_overall = res.data.total_overall;
                            this.date_size = res.data.date_size;
                            this.org_basic_data = res.data.org_basic_data;
                            this.total_working_days = res.data.total_working_days;
                            this.total_holidays = res.data.total_holidays;
                            this.overlay = false;
                        }else if (res.data.flag == "NO") {
                            this.showSnackbar("red", res.data.fmsg);
                        }else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.overlay = false;
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            putnull() {
                this.learner = [];
            },
            onLoad() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    role: this.role,
                };
                axios
                    .post("/commonAPI/get_ay_std_div_wws", data)
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                        this.status_list = res.data.status_list;
                        this.stud_status = this.status_list[0];
                        //this.month_list=res.data.month_list
                        this.year_list=res.data.year_list
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please Select Proper Data.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        },
        mounted() {
            this.onLoad();
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        watch: {},
    };
</script>
<style scoped>
    .table {
        border: none !important;
    }
    input[type="date"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
